import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { InformacaoCancelamentoMarcacaoConsultaDTO } from '../../dtos/informacao-cancelamento-marcacao-consulta-dto';
import { InformacaoCancelamentoMarcacaoProcedimentoDTO } from '../../dtos/informacao-cancelamento-marcacao-procedimento-dto';
import { MarcacaoDTO } from '../../dtos/marcacao-dto';
import { ResponseDTO } from '../../dtos/response-dto';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { MarcacaoConsultaService } from '../../marcacao/marcacao-consulta/marcacao-consulta.service';
import { MarcacaoConsultaPK } from '../../marcacao/marcacao-consulta/pks/marcacao-consulta-pk';
import { MarcacaoProcedimentoService } from '../../marcacao/marcacao-procedimento/marcacao-procedimento.service';
import { MarcacaoPK } from '../../marcacao/marcacao-procedimento/pks/marcacao-pk';
import { MotivoCancelamentoMarcacao } from '../../marcacao/motivo-cancelamento-marcacao';
import { MotivoCancelamento } from '../../motivo-cancelamento/motivo-cancelamento';
import { MotivoCancelamentoService } from '../../motivo-cancelamento/motivo-cancelamento.service';

@Component({
  selector: 'app-informacao-cancelamento-create',
  templateUrl: './informacao-cancelamento-create.component.html',
  styleUrls: ['./informacao-cancelamento-create.component.css']
})
export class InformacaoCancelamentoCreateComponent implements OnInit {

  formularioCancelamento: FormGroup;

  listaMotivoCancelamento: MotivoCancelamento[];

  marcacaoDTO: MarcacaoDTO;

  tipoMarcacao: TipoMarcacaoEnum | undefined;

  constructor(private marcacaoConsultaService: MarcacaoConsultaService,
    private marcacaoProcedimentoService: MarcacaoProcedimentoService,
    private motivoCancelamentoService: MotivoCancelamentoService,
    private router: Router,
    private dialog: MatDialog,
    private formBuilder: FormBuilder) {

    this.listaMotivoCancelamento = [];

    this.marcacaoDTO = Object.assign(new MarcacaoDTO(), history.state.marcacaoDTO);

    this.tipoMarcacao = history.state.tipoMarcacao as TipoMarcacaoEnum;

    if (!this.tipoMarcacao) {
      this.router.navigate(['/paginaInicial']);
    }

    this.formularioCancelamento = this.formBuilder.group({
      motivoCancelamento: ['', [Validators.required]],
      obsMotivoCancelamento: ['', [Validators.required]],
    });
  }

  ngOnInit() {

    this.listarMotivoCancelamento();

    this.configurarForm();
  }

  save() {

    const usuarioLogado: ResponseDTO = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (usuarioLogado && usuarioLogado.username) {
      const motivo: MotivoCancelamentoMarcacao = Object.assign(new MotivoCancelamentoMarcacao(), this.formularioCancelamento.value);
      motivo.loginUserCancelamento = usuarioLogado.username;

      if (this.tipoMarcacao === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {

        this.cancelarConsulta(motivo);

      } else if (this.tipoMarcacao === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {

        this.cancelarProcedimento(motivo);

      }

    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível cancelar a Marcação. Usuário logado não encontrado!'
        }
      });
    }
  }

  cancelarConsulta(motivo: MotivoCancelamentoMarcacao): void {
    const pk: MarcacaoConsultaPK = this.marcacaoDTO.getPkConsultaDaEntidade();

    const infoCancelamento: InformacaoCancelamentoMarcacaoConsultaDTO = new InformacaoCancelamentoMarcacaoConsultaDTO();
    infoCancelamento.pkMarcacao = pk;
    infoCancelamento.motivoCancelamentoMarcacao = motivo;

    this.marcacaoConsultaService
      .cancelarMarcacao(infoCancelamento).subscribe(data => {
        // console.log(data)

        this.gotoList();
      }, error => {
        console.log(error);
      });
  }

  cancelarProcedimento(motivo: MotivoCancelamentoMarcacao): void {
    const pk: MarcacaoPK = this.marcacaoDTO.getPkProcedimentoDaEntidade();

    const infoCancelamento: InformacaoCancelamentoMarcacaoProcedimentoDTO = new InformacaoCancelamentoMarcacaoProcedimentoDTO();
    infoCancelamento.pkMarcacao = pk;
    infoCancelamento.motivoCancelamentoMarcacao = motivo;

    this.marcacaoProcedimentoService
      .cancelarMarcacao(infoCancelamento).subscribe(data => {
        // console.log(data)

        this.gotoList();
      }, error => {
        console.log(error);
      });
  }

  onSubmit() {
    this.save();
  }

  gotoList() {

    if (this.tipoMarcacao === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA ||
      this.tipoMarcacao === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {

      const paginaAnterior = history.state.paginaAnterior;

      this.router.navigate(['/' + paginaAnterior], {
        state: {
          filtroMarcacao: history.state.filtroMarcacao,
          textFilter: history.state.textFilter,
        }
      });
    }

  }

  configurarForm(): void {
    this.formularioCancelamento.setValue({
      motivoCancelamento: '',
      obsMotivoCancelamento: '',
    });
  }

  listarMotivoCancelamento() {
    this.motivoCancelamentoService.listar()
      .subscribe(data => {

        // console.log(data)
        this.listaMotivoCancelamento = data;

      }, error => {
        console.log(error);
      });
  }

}
